var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "global__alert" },
    [
      _c(
        "b-modal",
        {
          staticClass: "modal-create-global-alert",
          attrs: {
            size: "lg",
            "hide-footer": "",
            id: "createGlobalAlert",
            title: "Create alert"
          },
          on: { hide: _vm.closeAlertDetail }
        },
        [_c("CreateGlobalAlert", { ref: "refCreateGlobalAlert" })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: {
            ok: function($event) {
              return _vm.deleteAlert(_vm.deleteAlertId)
            }
          },
          model: {
            value: _vm.confirmDeleteAlert,
            callback: function($$v) {
              _vm.confirmDeleteAlert = $$v
            },
            expression: "confirmDeleteAlert"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to delete this alert?")])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-global-alert-detail",
          attrs: { size: "lg", "hide-footer": "", id: "globalAlertDetail1" },
          on: { hide: _vm.closeAlertDetail }
        },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v("\n          " + _vm._s(_vm.alertTitle) + "\n          "),
            _c("p", { staticClass: "notification-sender" }, [
              _vm._v(
                "\n          sent by " +
                  _vm._s(_vm.alertSender) +
                  " @ " +
                  _vm._s(_vm.getLocalAlertTime(_vm.alertTime)) +
                  "\n          "
              )
            ])
          ]),
          _vm._v(" "),
          _c("span", { domProps: { innerHTML: _vm._s(_vm.alertDetail) } })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal-alert-status-detail",
          attrs: {
            size: "lg",
            "hide-footer": "",
            id: "alertStatusDetail",
            title: "Alert Status Log"
          },
          on: { hide: _vm.closeAlertDetail }
        },
        [
          _c(
            "table",
            { staticClass: "table table-striped table-bordered table-hover" },
            [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("User")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Status")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.alertStatusDetail, function(alertStatus, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [_vm._v(_vm._s(alertStatus.name))]),
                    _vm._v(" "),
                    _c("td", [
                      alertStatus.status == 1
                        ? _c("span", { staticClass: "badge badge-primary" }, [
                            _vm._v("Read")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      alertStatus.status == 0
                        ? _c("span", { staticClass: "badge badge-danger" }, [
                            _vm._v("Unread")
                          ])
                        : _vm._e()
                    ])
                  ])
                }),
                0
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("HeaderControls", {
        attrs: { namespace: _vm.namespace },
        on: { createNewAlert: _vm.createAlert }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "fixed-top-bar-padding" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "deliverable-header" }, [
            _c("h2", [
              _c(
                "div",
                {
                  staticClass: "media-call-icon",
                  on: { click: _vm.createAlert }
                },
                [
                  _c("img", {
                    attrs: {
                      width: "30px",
                      src: require("@/csmworkflow/img/bell-module.svg")
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(0)
                ]
              ),
              _vm._v("\n                  Global Alert\n              ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "global-alerts-status" }, [
            typeof _vm.allAlerts.data != "undefined" &&
            _vm.allAlerts.data.length == 0
              ? _c("span", [
                  _c("h2", [_vm._v("There are no alerts at the moment.")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "alert-item clearfix" }, [
              typeof _vm.allAlerts.data != "undefined" &&
              _vm.allAlerts.data.length > 0
                ? _c(
                    "ul",
                    { staticClass: "list-unstyled" },
                    _vm._l(_vm.allAlerts.data, function(alert, index) {
                      return _c(
                        "li",
                        {
                          key: "alert-" + index,
                          staticClass: "cursor-pointer",
                          attrs: { id: "alert-row-" + alert.id },
                          on: {
                            click: function($event) {
                              return _vm.setAlert(alert)
                            }
                          }
                        },
                        [
                          _c("div", [
                            _c("span", { staticClass: "info-bubbles" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "initials badge badge-primary cursor-pointer"
                                },
                                [
                                  _vm._v(
                                    "\n                                  " +
                                      _vm._s(
                                        _vm._f("textInitials")(alert.sender)
                                      ) +
                                      "\n                              "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "remove-alert cursor-pointer",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    _vm.confirmDeleteAlert = true
                                    _vm.deleteAlertId = alert.id
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-trash" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "alert-detail cursor-pointer",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.showStatusDetail(alert)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-info" })]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "details" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "alert__name cursor-pointer fw-bold"
                                },
                                [_vm._v(_vm._s(alert.title))]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "notification-sender" },
                                [
                                  _c("span", { staticClass: "fw-bold" }, [
                                    _vm._v(
                                      _vm._s(alert.sender) +
                                        " @ " +
                                        _vm._s(
                                          _vm.getLocalAlertTime(
                                            alert.created_at
                                          )
                                        )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "note-message",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.processMessage(alert.message)
                                  )
                                }
                              })
                            ])
                          ])
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("pagination", {
                  attrs: { data: _vm.allAlerts, limit: 5 },
                  on: { "pagination-change-page": _vm.onChangePage }
                })
              ],
              1
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "add-media-call-icon" }, [
      _c("img", { attrs: { src: require("@/csmworkflow/img/add-icon.svg") } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }